import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "./SearchBar";
import actions from "../store/Actions";
import "../App.css";
import CardsList from "./CardsList";
import NoResults from "./NoResults";

const getImagesAction = actions.getImagesAction;

const App = () => {
  const [initialImage, setInitialImage] = useState("");
  const [noResult, setNoResult] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const dispatch = useDispatch();

  const successData = useSelector((state) => state.getImages.successData);
  const loading = useSelector((state) => state.getImages.loading);

  useEffect(() => {
    if (successData && successData.length) {
      setInitialImage(successData[0].path);
      setNoResult(false);
    } else {
      setInitialImage("");
      setNoResult(isDataFetched ? true : false);
    }
  }, [successData]);

  const getSearchKeyword = (keyword) => {
    dispatch(getImagesAction(keyword));
    setIsDataFetched(true);
  };

  return (
    <div>
      <SearchBar
        getSearchKeyword={getSearchKeyword}
        initialImage={initialImage}
      />
      <div className="container">
        {!loading && <CardsList imageList={successData} />}
      </div>
      {noResult && isDataFetched && <NoResults />}
    </div>
  );
};

export default App;
